// AIP -> Adinplay ads a 3rd parth ad network https://adinplay.com/

import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {type UIAdElements} from './UIAdElements.ts'
import {type TimeoutId} from '@colonist/types'

declare let refreshAIPAd: (adId: string) => void

export class UIAIPAdController {
    private timer: TimeoutId
    private readonly UPDATE_AD_DURATION = 1000 * 30
    private readonly AIP_GAME_BOTTOM_SMALL = 'colonist-io_728x90_2'
    private readonly adElements: UIAdElements

    constructor(adElements: UIAdElements) {
        this.adElements = adElements
    }

    startRefreshing() {
        if(UIUtilsEjsVariables.showVliAdAtBottomInGame == true) return
        this.timer = setInterval(() => {
            this.refreshAIPAdIfShowing()
        }, this.UPDATE_AD_DURATION)
    }

    stopRefreshing() {
        if(this.timer == undefined) return
        clearInterval(this.timer)
    }

    private refreshAIPAdIfShowing() {
        if(this.adElements.containerGameBottomSmall == undefined) return
        if(window.getComputedStyle(this.adElements.containerGameBottomSmall).display == 'none') return
        if(refreshAIPAd == undefined) return
        refreshAIPAd(this.AIP_GAME_BOTTOM_SMALL)
    }
}
